export default function init() {
  document.addEventListener("DOMContentLoaded", function () {
    const pageColaboradores = document.querySelector("[js-page='colaboradores']");
    if (!pageColaboradores) return;

    const modal = document.getElementById("modal-colaborador");
    const fecharBtn = document.getElementById("fechar-modal");

    const modalNome = document.getElementById("modal-nome");
    const modalCargo = document.getElementById("modal-cargo");
    const modalDescricao = document.getElementById("modal-descricao");
    const modalImagem = document.getElementById("modal-imagem");

    const modalTelefoneTexto = document.getElementById("modal-telefone-texto");
    const modalTelefoneBotao = document.getElementById("modal-telefone-botao");

    const modalEmail = document.getElementById("modal-email");
    const modalLinkedin = document.getElementById("modal-linkedin");

    const modalAbraConta = document.getElementById("modal-abra-conta");
    const baseEl =
      document.querySelector("[js-page='colaboradores'][data-xpi-base]") ||
      pageColaboradores;

    const XPI_BASE =
      (baseEl?.dataset?.xpiBase || "").trim() ||
      "https://cadastro.xpi.com.br/v3/cadastro/nome?cb=1.1&assessor=";


    const cards = document.querySelectorAll(".card-colaborador");

    let whatsappLinkAtual = "";

    function gerarLinkWhatsApp(tel) {
      const numeros = (tel || "").replace(/\D/g, "");
      let telefone = numeros;
      if (!telefone.startsWith("55")) telefone = "55" + telefone;
      return `https://wa.me/${telefone}`;
    }

    function montarLinkXPI(codigoAssessor) {
      const codigo = (codigoAssessor || "").trim();
      if (!XPI_BASE || !codigo) return "";

      if (XPI_BASE.includes("{codigo}")) {
        return XPI_BASE.replace("{codigo}", encodeURIComponent(codigo));
      }

      if (XPI_BASE.includes("assessor=")) {
        return XPI_BASE + encodeURIComponent(codigo);
      }

      try {
        const url = new URL(XPI_BASE);
        url.searchParams.set("assessor", codigo);
        return url.toString();
      } catch (e) {
        const sep = XPI_BASE.includes("?") ? "&" : "?";
        return `${XPI_BASE}${sep}assessor=${encodeURIComponent(codigo)}`;
      }
    }

    cards.forEach((cardEl) => {
      const codigoAssessor = (cardEl.dataset.codigoAssessor || "").trim();
      const linkXPI = montarLinkXPI(codigoAssessor);

      const btnAbraContaCard = cardEl.querySelector("[data-abra-conta]");
      if (btnAbraContaCard) {
        btnAbraContaCard.href = linkXPI || "#";
        if (!linkXPI) btnAbraContaCard.classList.add("pointer-events-none", "opacity-50");
        else btnAbraContaCard.classList.remove("pointer-events-none", "opacity-50");
      }
    });

    cards.forEach((card) => {
      card.addEventListener("click", (e) => {
        const cardEl = e.target.closest(".card-colaborador");
        if (!cardEl) return;

        if (cardEl.dataset.clicavel === "0") return;

        modalNome.textContent = cardEl.dataset.nome || "";
        modalCargo.textContent = cardEl.dataset.cargo || "";
        modalDescricao.textContent = cardEl.dataset.descricao || "";
        modalImagem.src = cardEl.dataset.imagem || "";
        modalEmail.textContent = cardEl.dataset.email || "";
        modalLinkedin.href = cardEl.dataset.linkedin || "#";

        const telefoneRaw = cardEl.dataset.telefone || "";
        whatsappLinkAtual = gerarLinkWhatsApp(telefoneRaw);

        modalTelefoneTexto.textContent = telefoneRaw;
        modalTelefoneBotao.href = whatsappLinkAtual;
        modalTelefoneBotao.target = "_blank";
        modalTelefoneBotao.rel = "noopener noreferrer";

        const codigoAssessor = (cardEl.dataset.codigoAssessor || "").trim();
        const linkXPI = montarLinkXPI(codigoAssessor);

        if (linkXPI) {
          modalAbraConta.href = linkXPI;
          modalAbraConta.classList.remove("pointer-events-none", "opacity-50");
        } else {
          modalAbraConta.href = "#";
          modalAbraConta.classList.add("pointer-events-none", "opacity-50");
        }

        modalAbraConta.target = "_blank";
        modalAbraConta.rel = "noopener noreferrer";

        modal.classList.remove("hidden");
        modal.classList.add("flex");
        document.body.style.overflow = "hidden";
      });
    });

    modalTelefoneBotao.addEventListener("click", function (e) {
      if (whatsappLinkAtual) {
        e.preventDefault();
        window.open(whatsappLinkAtual, "_blank", "noopener,noreferrer");
      }
    });

    fecharBtn.addEventListener("click", () => {
      modal.classList.remove("flex");
      modal.classList.add("hidden");
      document.body.style.overflow = "";
    });

    const inputNome = document.querySelector("input[placeholder='Nome']");
    const inputCidade = document.querySelector("input[placeholder='Cidade']");
    const botaoPesquisar = document.querySelector("a.cursor-pointer");

    if (botaoPesquisar && inputNome && inputCidade) {
      botaoPesquisar.addEventListener("click", () => {
        let filtroNome = inputNome.value.trim().toLowerCase();
        let filtroCidade = inputCidade.value.trim().toLowerCase();

        if (filtroCidade.includes("granja")) filtroCidade = "cotia";

        cards.forEach((card) => {
          const nome = (card.dataset.nome || "").toLowerCase();
          let cidade = (card.dataset.cidade || "").toLowerCase();

          if (cidade.includes("granja")) cidade = "cotia";

          const mostraPorNome = filtroNome === "" || nome.includes(filtroNome);
          const mostraPorCidade = filtroCidade === "" || cidade.includes(filtroCidade);

          card.style.display = mostraPorNome && mostraPorCidade ? "flex" : "none";
        });
      });
    }

    function ajustarLinksWhatsapp() {
      const linksWhatsApp = document.querySelectorAll("a[href*='wa.me']");
      linksWhatsApp.forEach((link) => {
        let href = link.getAttribute("href") || "";
        let telefoneRaw = href.replace(/https:\/\/wa\.me\//, "");
        let telefoneLimpo = telefoneRaw.replace(/\D/g, "");
        if (!telefoneLimpo.startsWith("55")) telefoneLimpo = "55" + telefoneLimpo;
        link.setAttribute("href", `https://wa.me/${telefoneLimpo}`);
      });
    }

    ajustarLinksWhatsapp();
  });
}
